import { useContext } from "react";
import { StoreContext } from "./context";

const useStoreState = () => useContext(StoreContext).state;

const useDispatch = () => useContext(StoreContext);

export { useStoreState, useDispatch };
